module.exports = __webpack_public_path__ + "img/mykoob_logo.f02015a2.png";